module.exports = "<img class=\"continue\" src=\"/img/common/button_continue.png\" data-action=\"psl_router.route\" data-data=\"/page_29\"/>\n";